import { render } from "./DiagramComponentEditorCmp.vue?vue&type=template&id=2069a3e1"
import script from "./DiagramComponentEditorCmp.vue?vue&type=script&lang=js"
export * from "./DiagramComponentEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__